import {
  Box,
  Columns,
  Column,
  Heading,
  Stack,
  Text,
  ContentBlock,
} from 'braid-design-system';
import React from 'react';
import parseHtml from 'react-html-parser';

import { encodeSvg } from 'src/shared/helpers';

import * as styles from './ProductPromoTiles.css';

interface Props {
  title?: string;
  firstRowTiles: any[];
  secondRowTiles: any[];
}

export const ProductPromoTiles = ({
  title,
  firstRowTiles,
  secondRowTiles,
}: Props) => (
  <ContentBlock>
    <Box style={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        padding={['gutter', 'xlarge']}
        paddingBottom="large"
        className={styles.wrapper}
      >
        <Heading align="center" level="2">
          {title}
        </Heading>
      </Box>
      <Box style={{ position: 'relative' }}>
        <Columns
          collapseBelow="tablet"
          space={['gutter', 'none']}
          alignY="top"
          align="center"
        >
          {firstRowTiles.map((obj: any, key: number) => (
            <Box key={key}>
              <Column key={key}>
                <Box padding="gutter" paddingBottom="large">
                  <Stack space="small" align="center">
                    <Box
                      className={styles.image}
                      style={{
                        backgroundImage: encodeSvg(obj.icon),
                      }}
                    />
                    <Box textAlign="center" style={{ maxWidth: '300px' }}>
                      <Text size="large">{parseHtml(obj.text)}</Text>
                    </Box>
                  </Stack>
                </Box>
              </Column>
            </Box>
          ))}
        </Columns>
      </Box>
      <Box style={{ position: 'relative' }} paddingTop={['none', 'xlarge']}>
        <Columns
          collapseBelow="tablet"
          space={['gutter', 'none']}
          alignY="top"
          align="center"
        >
          {secondRowTiles.map((obj: any, key: number) => (
            <Box key={key}>
              <Column key={key}>
                <Box padding="gutter" paddingBottom="large">
                  <Stack space="small" align="center">
                    <Box
                      className={styles.image}
                      style={{
                        backgroundImage: encodeSvg(obj.icon),
                      }}
                    />
                    <Box textAlign="center" style={{ width: '300px' }}>
                      <Text size="large">{parseHtml(obj.text)}</Text>
                    </Box>
                  </Stack>
                </Box>
              </Column>
            </Box>
          ))}
        </Columns>
      </Box>
    </Box>
  </ContentBlock>
);
